<div class="hub-edit-financials-container">
    <ul class="nav nav-tabs nav-tabs-bottom mb-0">
        <li class="nav-item">
            <a href="#" (click)="setTabTo(tabs.workdayProjects, $event)" class="nav-link"
                [ngClass]="{active: activeTab === tabs.workdayProjects}">Workday Projects</a>
        </li>
        <li class="nav-item">
            <a href="#" (click)="setTabTo(tabs.estimatedFinancials, $event)" class="nav-link"
                [ngClass]="{active: activeTab === tabs.estimatedFinancials}">Estimated Financials</a>
        </li>
        <li class="nav-item">
            <a href="#" (click)="setTabTo(tabs.notes, $event)" class="nav-link"
                [ngClass]="{active: activeTab === tabs.notes}">Notes</a>
        </li>
    </ul>

    <div class="tab-content">
        <div class="tab-pane fade p-0"
            [ngClass]="{active: activeTab === tabs.workdayProjects, show: activeTab === tabs.workdayProjects}">

            <app-workday-projects-panel></app-workday-projects-panel>
        </div>

        <div class="tab-pane fade active p-0"
            [ngClass]="{active: activeTab === tabs.estimatedFinancials, show: activeTab === tabs.estimatedFinancials}">
            <app-estimated-financials-panel></app-estimated-financials-panel>
        </div>

        <div class="tab-pane fade p-2" [ngClass]="{active: activeTab === tabs.notes, show: activeTab === tabs.notes}">
            <app-notes-panel></app-notes-panel>
        </div>

    </div>
</div>
